/**
 * @author Jersson Morales
 * @Copyright (c) Infotrack. All rights reserved.
 */
import { useProveedor } from '@infotrack/presentacion-componentes/proveedorEstado';
import Texto from '@infotrack/presentacion-componentes/texto';
import { useInputState } from '@infotrack/presentacion-utilitarios/hooks';
import {
    manejadorDialogoGlobal,
    manejadorIndicadorCargaGlobal,
} from '@infotrack/presentacion-utilitarios/manejadoresComponentes';
import IBodegaDivisiones from 'Infotrack@Modelos/smartStock/bodegasDivisiones/entidades/bodegasDivisiones';
import IDivisionesDocumentosDefecto from 'Infotrack@Modelos/smartStock/divisionesDocumentosDefecto/entidades/divisionesDocumentosDefecto';
import ITipoDocumento from 'Infotrack@Modelos/smartStock/tiposDocumentos/entidades/tipoDocumento';
import { IEstadoGlobal } from 'Infotrack@Reductores/interfacesReductores';
import React from 'react';
import { connect } from 'react-redux';
import DivisionesDocumentosDefectoCM from '../controladorModelo/divisionesDocumentosDefectoCM';
import EntidadesDivisionesDocumentoCM from '../controladorModelo/entidadesDivisionesDocumentoCM';
import { IFormularioDivisionesDocumentosDefectoCVProps, IInputsDivisionesDocumentosDefecto } from '../interfaces';
import { acciones, IEstadoGestionBodegas } from '../reductorGestionBodegas';
import FormularioDivisionesDocumentosDefectoVista from '../vista/formularioDivisionesDocumentosDefectoVista';
import { estadoActivo } from 'Infotrack@Transversales/constantes/ConstantesEstados';

const estadoInicial: IInputsDivisionesDocumentosDefecto = {
    BodegaId: 0,
    DivisionId: '',
    EmpresaId: '',
    TipoDocumentoId: '',
    DivisionDefecto: false,
};
const divisionesDocumentosDefectoCM = new DivisionesDocumentosDefectoCM();
const entidadesDivisionesDocumentoCM = new EntidadesDivisionesDocumentoCM();

const FormularioDivisionesDocumentosDefectoCV: React.FunctionComponent<IFormularioDivisionesDocumentosDefectoCVProps> = ({
    IdEmpresa,
    IdAgencia,
}) => {
    const cargaInicial = React.useRef(true);
    const [
        {
            bodega,
            estadoFormularioDivionesPorDefecto,
            recargarEntidadesDivionesPorDefecto,
            entidadDivionesPorDefecto,
            listaTiposDocumentos,
            listaDivisiones,
        },
        dispatch,
    ] = useProveedor<IEstadoGestionBodegas>();
    const { alCambiarValor, setValor, reiniciar, valor } = useInputState<IInputsDivisionesDocumentosDefecto>(
        estadoInicial
    );
    const [divisiones, setDivisiones] = React.useState<IBodegaDivisiones[]>([]);
    const [tiposDocumentos, setTiposDocumentos] = React.useState<ITipoDocumento[]>([]);

    // React.useEffect(() => {
    //  cargarEntidadesDivisionesDefecto();
    // }, []);

    React.useEffect(() => {
        if (recargarEntidadesDivionesPorDefecto || cargaInicial.current) {
            cargarEntidadesDivisionesDefecto();
            if (recargarEntidadesDivionesPorDefecto) {
                dispatch({ type: acciones.RECARGAR_ENTIDADES_DIVISIONES_POR_DEFECTO });
            }
        }
        cargaInicial.current = false;
    }, [recargarEntidadesDivionesPorDefecto]);
    const cerrarFormulario = () => {
        dispatch({ type: acciones.CAMBIAR_ESTADO_FORMULARIO_DIVISIONES_POR_DEFECTO });
    };

    const confirmarCreacionEdicionDivisionesDocumentosDefecto = () => {
        if (divisionesDocumentosDefectoCM.validarEntidad(mapearDatos())) {
            manejadorDialogoGlobal({
                accionCancelar: () => manejadorDialogoGlobal({ estado: false }),
                accionConfirmar: crearEditarDivisionesDocumentosDefecto,
                estado: true,
                mensaje: <Texto id="alerta.confirmacionCreacion" />,
                mostrarCancelar: true,
                tipoDialogo: 'Advertencia',
                titulo: <Texto id="titulo.advertencia" />,
            });
        }
    };

    const crearEditarDivisionesDocumentosDefecto = () => {
        manejadorDialogoGlobal({ estado: false });
        manejadorIndicadorCargaGlobal(true);
        divisionesDocumentosDefectoCM.crearDivisionesDocumentosDefecto(mapearDatos()).then(() => {
            manejadorIndicadorCargaGlobal(false);
            dispatch({ type: acciones.RECARGAR_TABLA_DIVISIONES_POR_DEFECTO });
            reiniciar();
            cerrarFormulario();
        });
    };

    const cargarEntidadesDivisionesDefecto = () => {
        entidadesDivisionesDocumentoCM
            .consultarDivisionesFiltro(
                { BodegaId: Number(bodega.BodegaId),Estado:estadoActivo },
                { EmpresaId: IdEmpresa,Estado:estadoActivo }
            )
            .then(({ divisiones: divisionesCargadas, tiposDocumentos: tiposDocumentosCargados }) => {
                setDivisiones(divisionesCargadas);
                setTiposDocumentos(tiposDocumentosCargados);
            });
    };

    const mapearDatos = (): IDivisionesDocumentosDefecto => ({
        EmpresaId: IdEmpresa,  
        BodegaId: Number(bodega.BodegaId),
        DivisionId: Number(valor.DivisionId),
        TipoDocumentoId: Number(valor.TipoDocumentoId),
        DivisionDefecto: valor.DivisionDefecto,
    });

    return (
        <FormularioDivisionesDocumentosDefectoVista
            accionCrearEditar={confirmarCreacionEdicionDivisionesDocumentosDefecto}
            cambiarInfoFomulario={alCambiarValor}
            divisionesDocumentosDefecto={valor}
            cerrarFormulario={cerrarFormulario}
            entidadesFormulario={{ divisiones, tiposDocumentos }}
            estadoFormulario={estadoFormularioDivionesPorDefecto}
        />
    );
};

const estadoAPropiedades = ({
    estadoAutenticacion: { usuarioInformacion, agenciaActual },
}: IEstadoGlobal): IFormularioDivisionesDocumentosDefectoCVProps => ({
    IdEmpresa: usuarioInformacion!.IdEmpresa,
    IdAgencia: agenciaActual!.IdAgencia,
});

export default connect<IFormularioDivisionesDocumentosDefectoCVProps, null, any, IEstadoGlobal>(
    estadoAPropiedades,
    null
)(FormularioDivisionesDocumentosDefectoCV);
